<script>
import { isEqual } from 'lodash';
// Mixins
import mixinManagedTeamsUtils from '@/mixins/managed-teams-utils.vue';


export default {

  mixins: [mixinManagedTeamsUtils],

  computed: {
    /** Array: Array of the selected teams, defaults to teams managed by current team */
    selectedTeamIds: {
      get() {
        const { mgtTeams } = this.$route.query;
        if (mgtTeams !== undefined) {
          let teams = mgtTeams.split(',');
          if (teams) {
            teams = teams.map(id => Number(id));
            const ids = teams.filter(id => this.allTeams.map(t => t.id).includes(id));
            return ids;
          }
        }
        return this.utilsManagedTeams.map(t => t.id);
      },
      set(teams) {
        const query = Object.assign({}, this.$route.query);
        query.mgtTeams = teams.filter(id => this.allTeams.map(t => t.id).includes(id)).join(',');
        if (!isEqual(query, this.$route.query)) {
          this.$router.replace({ query });
        }
      },
    },
    /** Array: Array of selected team objects */
    selectedTeams() {
      return this.allTeams.filter(team => this.selectedTeamIds.includes(team.id));
    },
    /** Array: Array of selected team objects */
    teamsPerId() {
      return this.allTeams.reduce((all, team) => ({ ...all, [`${team.id}`]: team }), {});
    },
  },

  watch: {
    selectedTeamIds(newVal, oldVal) {
      if (!isEqual(newVal, oldVal)) {
        this.refresh();
      }
    },
  },

  methods: {
    refresh() {},
  },

};
</script>
